import { toString as toString_1, FSharpRef, Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { QwKey, AdminModels_AnswersBundle__GetQw_Z4F1B94C2, AdminModels_Range, AdminModels_AnswersBundle__UpdateAnswers, AdminModels_Answer, AdminModels_AnswersBundle__FindAnswers, AdminModels_AnswersBundle__GetAw, AdminModels_Range_$reflection, QwKey_$reflection, RESP$1_$reflection, AdminModels_AnswersBundle_$reflection } from "../shared/Shared.fs.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name, record_type, anonRecord_type, bool_type, union_type, unit_type, int32_type, option_type, class_type, string_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { empty as empty_1, ofList, FSharpMap__TryGetValue, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { subtract, utcNow, minValue } from "./fable_modules/fable-library.4.10.0/Date.js";
import { splitByLines, timeDiff, Infra_urlWithNewHashQuery, apiCmd$0027, Infra_getUrlHashParts, apiCmd, noCmd, serverTime, compareDates } from "./Common.fs.js";
import { unwrap, value as value_2, defaultArg } from "./fable_modules/fable-library.4.10.0/Option.js";
import { length, cons, filter, sortBy, reverse, ofArray, map as map_1, singleton, empty, fold } from "./fable_modules/fable-library.4.10.0/List.js";
import { int32ToString, equals, compare as compare_1, comparePrimitives, defaultOf } from "./fable_modules/fable-library.4.10.0/Util.js";
import { op_UnaryNegation, toString, tryParse, fromParts, compare } from "./fable_modules/fable-library.4.10.0/Decimal.js";
import Decimal from "./fable_modules/fable-library.4.10.0/Decimal.js";
import { Convert_fromJson, Convert_serialize } from "./fable_modules/Fable.SimpleJson.3.24.0/./Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/./TypeInfo.Converter.fs.js";
import { match } from "./fable_modules/fable-library.4.10.0/RegExp.js";
import { parse } from "./fable_modules/fable-library.4.10.0/Int32.js";
import { printf, toText } from "./fable_modules/fable-library.4.10.0/String.js";
import { Cmd_batch } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Navigation_modifyUrl } from "./fable_modules/Fable.Elmish.Browser.4.1.0/navigation.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/./SimpleJson.fs.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import { collect, map as map_2, append, singleton as singleton_1, empty as empty_2, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import * as react from "react";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { HTMLAttr, DOMAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { totalSeconds } from "./fable_modules/fable-library.4.10.0/TimeSpan.js";
import { rangeDouble } from "./fable_modules/fable-library.4.10.0/Range.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GetAnswersResp", "DeleteError", "Exn", "SelectQuestion", "ToggleShowAllTeams", "SelectRange", "ResultChanged", "ResultWithoutAnswer", "ResultsUpdated"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminAnswers.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(AdminModels_AnswersBundle_$reflection())]], [["Item", string_type]], [["Item", class_type("System.Exception")]], [["Item", QwKey_$reflection()]], [], [["Item", option_type(AdminModels_Range_$reflection())]], [["teamId", int32_type], ["key", QwKey_$reflection()], ["res", string_type]], [["teamId", int32_type], ["key", QwKey_$reflection()], ["res", string_type]], [["Item", RESP$1_$reflection(unit_type)]]]);
}

export class Model extends Record {
    constructor(Bundle, Errors, IsLoading, CurrentQuestion, ShowAllTeams, TimeDiff, LastReviews, SessionStart, Range$) {
        super();
        this.Bundle = Bundle;
        this.Errors = Errors;
        this.IsLoading = IsLoading;
        this.CurrentQuestion = CurrentQuestion;
        this.ShowAllTeams = ShowAllTeams;
        this.TimeDiff = TimeDiff;
        this.LastReviews = LastReviews;
        this.SessionStart = SessionStart;
        this.Range = Range$;
    }
}

export function Model_$reflection() {
    return record_type("AdminAnswers.Model", [], Model, () => [["Bundle", option_type(AdminModels_AnswersBundle_$reflection())], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["IsLoading", bool_type], ["CurrentQuestion", option_type(anonRecord_type(["Key", QwKey_$reflection()], ["LastReview", class_type("System.DateTime")]))], ["ShowAllTeams", bool_type], ["TimeDiff", class_type("System.TimeSpan")], ["LastReviews", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [QwKey_$reflection(), class_type("System.DateTime")])], ["SessionStart", class_type("System.DateTime")], ["Range", option_type(AdminModels_Range_$reflection())]]);
}

export const TEAMsOnPAGE = 250;

export function getActualPoints(jpd, qw) {
    let pt, pt_1;
    const matchValue = qw.JpdPt;
    let matchResult, pt_2, pt_3;
    if (matchValue != null) {
        if ((pt = matchValue, !qw.Ch)) {
            matchResult = 0;
            pt_2 = matchValue;
        }
        else if ((pt_1 = matchValue, qw.Ch && jpd)) {
            matchResult = 1;
            pt_3 = matchValue;
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return pt_2;
        case 1:
            return pt_3;
        default:
            return qw.Pt;
    }
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Bundle, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt), model.IsLoading, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, model.Range);
}

export function delError(id, model) {
    return new Model(model.Bundle, FSharpMap__Remove(model.Errors, id), model.IsLoading, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, model.Range);
}

export function loading(model) {
    return new Model(model.Bundle, model.Errors, true, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, model.Range);
}

export function editing(model) {
    return new Model(model.Bundle, model.Errors, false, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, model.Range);
}

export function reviewTime(key, model) {
    let matchValue;
    let outArg = minValue();
    matchValue = [FSharpMap__TryGetValue(model.LastReviews, key, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return model.SessionStart;
    }
}

export function isNewAnswer(aw, lastReview) {
    let matchResult;
    if (aw.Res != null) {
        if (aw.IsA && (compareDates(defaultArg(aw.UT, minValue()), lastReview) > 0)) {
            matchResult = 1;
        }
        else {
            matchResult = 2;
        }
    }
    else if (compareDates(aw.RT, lastReview) > 0) {
        matchResult = 0;
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return true;
        default:
            return false;
    }
}

export function questionStats(key, model) {
    let matchValue_1;
    const lastReview = reviewTime(key, model);
    return fold((r, team) => {
        let matchValue;
        let outArg = defaultOf();
        matchValue = [FSharpMap__TryGetValue(team.Awrs, key, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            const aw = matchValue[1];
            const res = aw.Res;
            const Total = (r.Total + 1) | 0;
            const Win = (r.Win + (((res != null) && (compare(value_2(res), fromParts(0, 0, 0, false, 0)) > 0)) ? 1 : 0)) | 0;
            const Open = (r.Open + ((res == null) ? 1 : 0)) | 0;
            return {
                Lose: r.Lose + (((res != null) && (compare(value_2(res), fromParts(0, 0, 0, false, 0)) <= 0)) ? 1 : 0),
                New: r.New + (isNewAnswer(aw, lastReview) ? 1 : 0),
                Open: Open,
                Total: Total,
                Win: Win,
            };
        }
        else {
            return r;
        }
    }, {
        Lose: 0,
        New: 0,
        Open: 0,
        Total: 0,
        Win: 0,
    }, (matchValue_1 = model.Bundle, (matchValue_1 != null) ? matchValue_1.Teams : empty()));
}

export function selectQuestion(idx, model) {
    const currentQuestion = {
        Key: idx,
        LastReview: reviewTime(idx, model),
    };
    const lastReviews = FSharpMap__Add(model.LastReviews, idx, serverTime(model.TimeDiff));
    sessionStorage.setItem("AnswersLR", Convert_serialize(lastReviews, createTypeInfo(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [QwKey_$reflection(), class_type("System.DateTime")]))));
    return new Model(model.Bundle, model.Errors, model.IsLoading, currentQuestion, model.ShowAllTeams, model.TimeDiff, lastReviews, model.SessionStart, model.Range);
}

export function setResults(api, teamId, key, v, model) {
    let res;
    let matchValue;
    let outArg = new Decimal("0");
    matchValue = [tryParse(v, new FSharpRef(() => outArg, (v_1) => {
        outArg = v_1;
    })), outArg];
    res = (matchValue[0] ? matchValue[1] : void 0);
    const matchValue_1 = model.Bundle;
    if (matchValue_1 == null) {
        return noCmd(model);
    }
    else {
        const bundle = matchValue_1;
        const matchValue_2 = AdminModels_AnswersBundle__GetAw(bundle, teamId, key);
        if (matchValue_2 == null) {
            return noCmd(model);
        }
        else {
            const aw = matchValue_2;
            const answersToResult = (aw.Txt !== "") ? AdminModels_AnswersBundle__FindAnswers(bundle, key, aw.Txt, aw.Jpd) : singleton([teamId, aw]);
            const answersToUpdate = ofList(map_1((tupledArg) => {
                const aw_1 = tupledArg[1];
                return [tupledArg[0], new AdminModels_Answer(aw_1.Txt, aw_1.Jpd, aw_1.RT, res, false, serverTime(model.TimeDiff))];
            }, answersToResult), {
                Compare: comparePrimitives,
            });
            return apiCmd(api.updateResults, map_1((tupledArg_1) => ({
                QwKey: key,
                Res: unwrap(res),
                TeamId: tupledArg_1[0],
            }), answersToResult), (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(2, [Item_1])), loading(new Model(AdminModels_AnswersBundle__UpdateAnswers(bundle, key, answersToUpdate), model.Errors, model.IsLoading, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, model.Range)));
        }
    }
}

export function setResultWithoutAnswer(api, teamId, key, v, model) {
    let res;
    let matchValue;
    let outArg = new Decimal("0");
    matchValue = [tryParse(v, new FSharpRef(() => outArg, (v_1) => {
        outArg = v_1;
    })), outArg];
    res = (matchValue[0] ? matchValue[1] : void 0);
    const matchValue_1 = model.Bundle;
    if (matchValue_1 == null) {
        return noCmd(model);
    }
    else {
        const bundle = matchValue_1;
        const answersToResult = singleton([teamId, new AdminModels_Answer("", false, utcNow(), res, false, void 0)]);
        const answersToUpdate = ofList(map_1((tupledArg) => {
            const aw_1 = tupledArg[1];
            return [tupledArg[0], new AdminModels_Answer(aw_1.Txt, aw_1.Jpd, aw_1.RT, res, false, serverTime(model.TimeDiff))];
        }, answersToResult), {
            Compare: comparePrimitives,
        });
        return apiCmd(api.updateResultsWithoutAnswer, map_1((tupledArg_1) => ({
            QwKey: key,
            Res: unwrap(res),
            TeamId: tupledArg_1[0],
        }), answersToResult), (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(2, [Item_1])), loading(new Model(AdminModels_AnswersBundle__UpdateAnswers(bundle, key, answersToUpdate), model.Errors, model.IsLoading, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, model.Range)));
    }
}

export function rangeFromHashQuery() {
    const m = match(/:(\d+)-(\d+)/gu, Infra_getUrlHashParts()[1]);
    if (m != null) {
        return new AdminModels_Range(parse(m[1] || "", 511, false, 32), parse(m[2] || "", 511, false, 32));
    }
    else {
        return void 0;
    }
}

export function setRange(api, range, model) {
    let hashQuery;
    if (range == null) {
        hashQuery = "";
    }
    else {
        const range_1 = range;
        hashQuery = toText(printf(":%i-%i"))(range_1.From)(range_1.To);
    }
    return [new Model(model.Bundle, model.Errors, true, model.CurrentQuestion, model.ShowAllTeams, model.TimeDiff, model.LastReviews, model.SessionStart, range), Cmd_batch(ofArray([apiCmd$0027(api.getAnswers, range, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1]))), Navigation_modifyUrl(Infra_urlWithNewHashQuery(hashQuery))]))];
}

export function init(api, user) {
    let matchValue_1, matchValue_4;
    let lastReviews;
    let matchValue_2;
    const str = sessionStorage.getItem("AnswersLR");
    let matchValue;
    try {
        matchValue = (new FSharpResult$2(0, [(matchValue_1 = SimpleJson_tryParse(str), (matchValue_1 != null) ? Convert_fromJson(matchValue_1, createTypeInfo(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [QwKey_$reflection(), class_type("System.DateTime")]))) : (() => {
            throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
        })())]));
    }
    catch (ex) {
        matchValue = (new FSharpResult$2(1, [ex.message]));
    }
    matchValue_2 = ((matchValue.tag === 1) ? void 0 : matchValue.fields[0]);
    lastReviews = ((matchValue_2 == null) ? empty_1({
        Compare: compare_1,
    }) : matchValue_2);
    let sessionStart;
    let matchValue_5;
    const str_1 = sessionStorage.getItem("AnswersSS");
    let matchValue_3;
    try {
        matchValue_3 = (new FSharpResult$2(0, [(matchValue_4 = SimpleJson_tryParse(str_1), (matchValue_4 != null) ? Convert_fromJson(matchValue_4, createTypeInfo(class_type("System.DateTime"))) : (() => {
            throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
        })())]));
    }
    catch (ex_1) {
        matchValue_3 = (new FSharpResult$2(1, [ex_1.message]));
    }
    matchValue_5 = ((matchValue_3.tag === 1) ? void 0 : matchValue_3.fields[0]);
    if (matchValue_5 == null) {
        const sst_1 = utcNow();
        sessionStorage.setItem("AnswersSS", Convert_serialize(sst_1, createTypeInfo(class_type("System.DateTime"))));
        sessionStart = sst_1;
    }
    else {
        sessionStart = matchValue_5;
    }
    const range = rangeFromHashQuery();
    return apiCmd(api.getAnswers, range, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1])), new Model(void 0, empty_1({
        Compare: comparePrimitives,
    }), true, void 0, false, 0, lastReviews, sessionStart, range));
}

export function update(api, user, msg, cm) {
    let matchResult, res_2, st, key, range, key_1, teamId, v, key_2, teamId_1, v_1, id, ex, txt_3;
    switch (msg.tag) {
        case 3: {
            matchResult = 1;
            key = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 2;
            break;
        }
        case 5: {
            matchResult = 3;
            range = msg.fields[0];
            break;
        }
        case 6: {
            matchResult = 4;
            key_1 = msg.fields[1];
            teamId = msg.fields[0];
            v = msg.fields[2];
            break;
        }
        case 7: {
            matchResult = 5;
            key_2 = msg.fields[1];
            teamId_1 = msg.fields[0];
            v_1 = msg.fields[2];
            break;
        }
        case 8: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 6;
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 9;
                    txt_3 = activePatternResult;
                }
                else {
                    matchResult = 10;
                }
            }
            break;
        }
        case 1: {
            matchResult = 7;
            id = msg.fields[0];
            break;
        }
        case 2: {
            matchResult = 8;
            ex = msg.fields[0];
            break;
        }
        default:
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 0;
                res_2 = msg.fields[0].Value.fields[0];
                st = msg.fields[0].ST;
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 9;
                    txt_3 = activePatternResult_1;
                }
                else {
                    matchResult = 10;
                }
            }
    }
    switch (matchResult) {
        case 0:
            return noCmd(editing(new Model(res_2, cm.Errors, cm.IsLoading, cm.CurrentQuestion, cm.ShowAllTeams, timeDiff(st), cm.LastReviews, cm.SessionStart, cm.Range)));
        case 1:
            return noCmd(selectQuestion(key, cm));
        case 2:
            return noCmd(new Model(cm.Bundle, cm.Errors, cm.IsLoading, cm.CurrentQuestion, !cm.ShowAllTeams, cm.TimeDiff, cm.LastReviews, cm.SessionStart, cm.Range));
        case 3:
            return setRange(api, range, cm);
        case 4:
            return setResults(api, teamId, key_1, v, cm);
        case 5:
            return setResultWithoutAnswer(api, teamId_1, key_2, v_1, cm);
        case 6:
            return noCmd(editing(cm));
        case 7:
            return noCmd(delError(id, cm));
        case 8:
            return noCmd(editing(addError(ex.message, cm)));
        case 9:
            return noCmd(editing(addError(txt_3, cm)));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, model) {
    let children_2, children, children_4, children_12;
    const children_14 = [(children_2 = [(children = toList(delay(() => {
        const matchValue = model.Bundle;
        if (matchValue == null) {
            return empty_2();
        }
        else {
            return singleton_1(menuView(dispatch, matchValue, model));
        }
    })), react.createElement("div", {}, ...children))], react.createElement("div", {
        className: "column is-narrow",
    }, ...children_2)), (children_4 = toList(delay(() => {
        const matchValue_1 = model.Bundle;
        let matchResult, bundle_1;
        if (matchValue_1 != null) {
            if (model.IsLoading) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                bundle_1 = matchValue_1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return append(singleton_1(paginator(dispatch, bundle_1, model.Range)), delay(() => {
                    const matchValue_4 = model.CurrentQuestion;
                    if (matchValue_4 != null) {
                        const cq = matchValue_4;
                        const matchValue_5 = AdminModels_AnswersBundle__GetQw_Z4F1B94C2(bundle_1, cq.Key);
                        if (matchValue_5 == null) {
                            return empty_2();
                        }
                        else {
                            return answersTable(dispatch, bundle_1, matchValue_5, cq, model.ShowAllTeams);
                        }
                    }
                    else {
                        return empty_2();
                    }
                }));
            default: {
                return empty_2();
            }
        }
    })), react.createElement("div", {
        className: "column is-8",
    }, ...children_4)), (children_12 = toList(delay(() => append(model.IsLoading ? singleton_1(react.createElement("button", {
        className: "button is-loading is-large is-fullwidth is-light",
    })) : empty_2(), delay(() => map_2((error) => {
        const children_10 = [react.createElement("button", {
            className: "delete",
            onClick: (_arg) => {
                dispatch(new Msg(1, [error[0]]));
            },
        }), error[1]];
        return react.createElement("div", {
            className: "notification is-danger is-light",
        }, ...children_10);
    }, model.Errors))))), react.createElement("div", {
        className: "column is-2",
    }, ...children_12))];
    return react.createElement("div", {
        className: "columns",
    }, ...children_14);
}

export function menuView(dispatch, bundle, model) {
    let children_10;
    const children_12 = [react.createElement("p", {
        className: "menu-label",
    }, "Questions"), (children_10 = toList(delay(() => map_2((qw) => {
        const children_8 = toList(delay(() => {
            let props_6, matchValue, children_6;
            return singleton_1((props_6 = [Helpers_classList([["light-item", true], ["has-background-white", equals(qw.Key, (matchValue = model.CurrentQuestion, (matchValue == null) ? (new QwKey(-1, -1)) : matchValue.Key))]]), new DOMAttr(40, [(_arg) => {
                dispatch(new Msg(3, [qw.Key]));
            }])], (children_6 = toList(delay(() => {
                const stats = questionStats(qw.Key, model);
                return append(singleton_1(toText(printf("%s - "))(qw.Nm)), delay(() => {
                    let children_2, copyOfStruct;
                    return append(singleton_1((children_2 = [(copyOfStruct = stats.Win, int32ToString(copyOfStruct))], react.createElement("span", {
                        className: "has-text-primary",
                    }, ...children_2))), delay(() => append(singleton_1(toText(printf("/%i"))(stats.Total)), delay(() => {
                        let children_4;
                        return (stats.New > 0) ? singleton_1((children_4 = [toText(printf(" (%i new)"))(stats.New)], react.createElement("span", {
                            className: "has-text-weight-bold",
                        }, ...children_4))) : empty_2();
                    }))));
                }));
            })), react.createElement("a", keyValueList(props_6, 1), ...children_6))));
        }));
        return react.createElement("li", {}, ...children_8);
    }, reverse(sortBy((q) => q.Key, bundle.Questions, {
        Compare: compare_1,
    }))))), react.createElement("ul", {
        className: "menu-list ",
    }, ...children_10))];
    return react.createElement("aside", {
        className: "menu",
    }, ...children_12);
}

export function answersTable(dispatch, bundle, qw, cq, showAllTeams) {
    return toList(delay(() => {
        let children;
        return append(singleton_1((children = [toText(printf("Question: %s  \"%s\""))(qw.Nm)(qw.Ann)], react.createElement("h5", {
            className: "title is-5",
        }, ...children))), delay(() => {
            let children_6, children_4;
            return append((qw.Awr !== "") ? singleton_1((children_6 = [react.createElement("b", {}, "Answer(s): "), (children_4 = splitByLines(qw.Awr), react.createElement("p", {}, ...children_4))], react.createElement("p", {
                className: "content",
            }, ...children_6))) : empty_2(), delay(() => {
                let children_8;
                return append(singleton_1((children_8 = [react.createElement("input", {
                    type: "checkbox",
                    checked: showAllTeams,
                    onChange: (_arg) => {
                        dispatch(new Msg(4, []));
                    },
                }), " show all teams"], react.createElement("label", {
                    className: "checkbox",
                }, ...children_8))), delay(() => {
                    let children_26;
                    return singleton_1((children_26 = toList(delay(() => {
                        let children_22, children_20, props_18, props_20;
                        return append(singleton_1((children_22 = [(children_20 = [react.createElement("th", {}, "Id"), react.createElement("th", {}, "Team"), react.createElement("th", {}, "Answer"), (props_18 = [["style", {
                            textAlign: "center",
                            width: "100px",
                        }]], react.createElement("th", keyValueList(props_18, 1), "Points")), (props_20 = [["style", {
                            width: "50px",
                        }]], react.createElement("th", keyValueList(props_20, 1), "Time"))], react.createElement("tr", {}, ...children_20))], react.createElement("thead", {}, ...children_22))), delay(() => {
                            let children_24;
                            const answers = sortBy((tupledArg_1) => tupledArg_1[0].Id, filter((tupledArg) => {
                                if (showAllTeams) {
                                    return true;
                                }
                                else {
                                    return tupledArg[1][0];
                                }
                            }, map_1((team) => {
                                let outArg;
                                return [team, (outArg = defaultOf(), [FSharpMap__TryGetValue(team.Awrs, qw.Key, new FSharpRef(() => outArg, (v) => {
                                    outArg = v;
                                })), outArg])];
                            }, bundle.Teams)), {
                                Compare: comparePrimitives,
                            });
                            return singleton_1((children_24 = toList(delay(() => collect((matchValue) => {
                                const team_2 = matchValue[0];
                                return matchValue[1][0] ? singleton_1(answersRow(dispatch, team_2, qw, matchValue[1][1], cq.LastReview)) : singleton_1(noAnswersRow(dispatch, team_2, qw));
                            }, answers))), react.createElement("tbody", {}, ...children_24)));
                        }));
                    })), react.createElement("table", {
                        className: "table is-hoverable is-fullwidth",
                    }, ...children_26)));
                }));
            }));
        }));
    }));
}

export function answersRow(dispatch, team, qw, aw, lastReview) {
    let res_2, res_3;
    let modifiers;
    const matchValue = aw.Res;
    modifiers = ((matchValue == null) ? empty() : ((compare(matchValue, fromParts(0, 0, 0, false, 0)) > 0) ? ((res_2 = matchValue, singleton(["has-text-success", true]))) : ((compare(matchValue, fromParts(0, 0, 0, false, 0)) <= 0) ? ((res_3 = matchValue, singleton(["has-text-danger", true]))) : empty())));
    const modifiers_1 = isNewAnswer(aw, lastReview) ? cons(["has-text-weight-bold", true], modifiers) : modifiers;
    const children_34 = toList(delay(() => {
        let children_2, props, children;
        return append(singleton_1((children_2 = [(props = [Helpers_classList(modifiers_1)], (children = [int32ToString(team.Id)], react.createElement("span", keyValueList(props, 1), ...children)))], react.createElement("td", {}, ...children_2))), delay(() => {
            let children_6, props_4;
            return append(singleton_1((children_6 = [(props_4 = [Helpers_classList(modifiers_1)], react.createElement("span", keyValueList(props_4, 1), team.Nm))], react.createElement("td", {}, ...children_6))), delay(() => {
                let children_10, props_8, children_8;
                return append(singleton_1((children_10 = [(props_8 = [Helpers_classList(modifiers_1)], (children_8 = toList(delay(() => append(aw.Jpd ? singleton_1(Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-paw"]), new Fa_IconOption(3, [])]), [])) : empty_2(), delay(() => singleton_1(aw.Txt))))), react.createElement("span", keyValueList(props_8, 1), ...children_8)))], react.createElement("td", {}, ...children_10))), delay(() => {
                    let children_26;
                    return append(singleton_1((children_26 = toList(delay(() => {
                        let children_24;
                        const points = getActualPoints(aw.Jpd, qw);
                        return singleton_1((children_24 = toList(delay(() => {
                            let children_14, children_12;
                            return append(singleton_1((children_14 = [(children_12 = [Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-plus-square"]), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])], react.createElement("span", {
                                className: "icon",
                            }, ...children_12))], react.createElement("a", {
                                className: "button is-small is-success is-inverted",
                                onClick: (_arg) => {
                                    dispatch(new Msg(6, [team.Id, qw.Key, toString(points)]));
                                },
                            }, ...children_14))), delay(() => {
                                let props_16;
                                return append(singleton_1((props_16 = [new HTMLAttr(65, ["input is-small"]), new HTMLAttr(159, ["number"]), ["style", {
                                    width: "50px",
                                }], new DOMAttr(9, [(ev) => {
                                    dispatch(new Msg(6, [team.Id, qw.Key, ev.target.value]));
                                }]), new HTMLAttr(161, [toString_1(aw.Res)])], react.createElement("input", keyValueList(props_16, 1)))), delay(() => {
                                    let children_18, children_16;
                                    return append(singleton_1((children_18 = [(children_16 = [Fa_i(ofArray([new Fa_IconOption(11, ["far fa-circle"]), new Fa_IconOption(0, [new Fa_ISize(0, [])])]), [])], react.createElement("span", {
                                        className: "icon",
                                    }, ...children_16))], react.createElement("a", {
                                        className: "button is-small",
                                        onClick: (_arg_1) => {
                                            dispatch(new Msg(6, [team.Id, qw.Key, ""]));
                                        },
                                    }, ...children_18))), delay(() => {
                                        let children_22, children_20;
                                        return (qw.JpdPt != null) ? singleton_1((children_22 = [(children_20 = [Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-minus-square"]), new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])], react.createElement("span", {
                                            className: "icon",
                                        }, ...children_20))], react.createElement("a", {
                                            className: "button is-small is-danger is-inverted",
                                            onClick: (_arg_2) => {
                                                let copyOfStruct;
                                                dispatch(new Msg(6, [team.Id, qw.Key, (copyOfStruct = op_UnaryNegation(points), toString(copyOfStruct))]));
                                            },
                                        }, ...children_22))) : empty_2();
                                    }));
                                }));
                            }));
                        })), react.createElement("div", {
                            className: "field has-addons",
                        }, ...children_24)));
                    })), react.createElement("td", {}, ...children_26))), delay(() => {
                        let children_30, props_30, children_28, copyOfStruct_2;
                        let matchValue_2;
                        const matchValue_1 = qw.ST;
                        matchValue_2 = ((matchValue_1 == null) ? void 0 : totalSeconds(subtract(aw.RT, matchValue_1)));
                        if (matchValue_2 == null) {
                            return singleton_1(react.createElement("td", {}));
                        }
                        else {
                            const seconds = matchValue_2;
                            return singleton_1((children_30 = [(props_30 = [Helpers_classList([["has-text-danger", ~~seconds > (qw.Sec + 20)]])], (children_28 = [(copyOfStruct_2 = ~~seconds, int32ToString(copyOfStruct_2))], react.createElement("span", keyValueList(props_30, 1), ...children_28)))], react.createElement("td", {}, ...children_30)));
                        }
                    }));
                }));
            }));
        }));
    }));
    return react.createElement("tr", {}, ...children_34);
}

export function noAnswersRow(dispatch, team, qw) {
    let children_2, children, children_6, children_10, props_8, children_14, children_12, props_12;
    const children_18 = [(children_2 = [(children = [int32ToString(team.Id)], react.createElement("span", {}, ...children))], react.createElement("td", {}, ...children_2)), (children_6 = [react.createElement("span", {}, team.Nm)], react.createElement("td", {}, ...children_6)), (children_10 = [(props_8 = [["style", {
        fontStyle: "italic",
    }]], react.createElement("span", keyValueList(props_8, 1), "== no answer =="))], react.createElement("td", {}, ...children_10)), (children_14 = [(children_12 = [(props_12 = [new HTMLAttr(65, ["input is-small"]), new HTMLAttr(159, ["number"]), ["style", {
        width: "50px",
    }], new DOMAttr(9, [(ev) => {
        dispatch(new Msg(7, [team.Id, qw.Key, ev.target.value]));
    }])], react.createElement("input", keyValueList(props_12, 1)))], react.createElement("div", {}, ...children_12))], react.createElement("td", {}, ...children_14)), react.createElement("td", {})];
    return react.createElement("tr", {}, ...children_18);
}

export function paginator(dispatch, bundle, range) {
    let children_12;
    const children_14 = [(children_12 = toList(delay(() => {
        let props;
        if (range == null) {
            const totalIndexes = ~~(length(bundle.Teams) / TEAMsOnPAGE) | 0;
            return (totalIndexes > 0) ? append(singleton_1(react.createElement("li", {
                className: "pagination-link is-current",
            }, "All teams")), delay(() => append(singleton_1(react.createElement("li", {
                className: "pagination-ellipsis",
            }, " ")), delay(() => collect((idx) => {
                let props_10, children_10;
                const range_2 = new AdminModels_Range((idx * TEAMsOnPAGE) + 1, (idx + 1) * TEAMsOnPAGE);
                return singleton_1((props_10 = [new HTMLAttr(65, ["pagination-link"]), ["style", {
                    cursor: "pointer",
                }], new DOMAttr(40, [(_arg_1) => {
                    dispatch(new Msg(5, [range_2]));
                }])], (children_10 = [toText(printf("%i-%i"))(range_2.From)(range_2.To)], react.createElement("li", keyValueList(props_10, 1), ...children_10))));
            }, rangeDouble(0, 1, totalIndexes)))))) : empty_2();
        }
        else {
            const range_1 = range;
            return append(singleton_1((props = [new HTMLAttr(65, ["pagination-link"]), ["style", {
                cursor: "pointer",
            }], new DOMAttr(40, [(_arg) => {
                dispatch(new Msg(5, [void 0]));
            }])], react.createElement("li", keyValueList(props, 1), "All teams"))), delay(() => append(singleton_1(react.createElement("li", {
                className: "pagination-ellipsis",
            }, " ")), delay(() => {
                let children_4;
                return singleton_1((children_4 = [toText(printf("%i-%i"))(range_1.From)(range_1.To)], react.createElement("li", {
                    className: "pagination-link is-current",
                }, ...children_4)));
            }))));
        }
    })), react.createElement("ul", {
        className: "pagination-list",
    }, ...children_12))];
    return react.createElement("nav", {
        className: "pagination",
        role: "navigation",
        "aria-label": "pagination",
    }, ...children_14);
}

